import { fetchArticleById } from 'core_main/api/articles';
import { createArticleCallbackResponse } from '../get_articles/helpers';
import {
  ArticleCallbackResponse,
  GetArticleByIdParameters,
} from '../get_articles/types';

export const getArticleById = (
  parameters: GetArticleByIdParameters,
  cb?: (res: ArticleCallbackResponse | null, err?: Error) => void,
) => {
  return fetchArticleById(parameters)
    .then((articleResponse) => {
      const callbackResponse = createArticleCallbackResponse(
        articleResponse.data,
      );

      if (typeof cb === 'function') {
        cb(callbackResponse);
      }
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      console.error('Failed to get article', error);
    });
};
